import { removeSkuPrefix } from 'src/util/Linx'
import { renderSnippet as renderSnippetGta } from './snippet-gtag'

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID

export const gtgProduto = (
  conteudoProduto: any,
  variacaoAtiva: any,
  gtgProdProps?: any
) => {
  if (!conteudoProduto || !variacaoAtiva) return null
  const anuncioProduto = variacaoAtiva.anuncios[0]
  const variacao = variacaoAtiva?.combinacoes.reduce(
    (result: any, item: any) => {
      if (
        (item.atributo_slug === 'voltagem' &&
          item.valor_slug != 'sem-voltagem') ||
        (item.atributo_slug === 'cor' && item.valor_slug != 'sem-cor')
      ) {
        result.push(item.valor)
      }
      return result
    },
    []
  )

  return {
    id: variacaoAtiva.id,
    name: conteudoProduto.titulo,
    /*list_name: 'Search Results',*/
    brand: conteudoProduto.marca_slug,
    category: conteudoProduto.categoria.nome,
    variant: variacao.join(','),
    list_position: 1,
    quantity: 1,
    price:
      anuncioProduto.formas_pagamento?.boleto?.por ?? anuncioProduto.preco.por,
    ...gtgProdProps,
  }
}

const gtgProdutoFromLinx = (product: any, gtgProdProps?: any) => {
  try {
    return {
      id: product.selectedSku,
      name: product.name,
      /*list_name: 'Search Results',*/
      /*brand: product.brand,*/
      category: product.cId,
      variant: product?.specs?.cor?.[0]?.label ?? '',
      list_position: 1,
      quantity: 1,
      price: product.price,
      ...gtgProdProps,
    }
  } catch (e) {
    console.log(product)
  }
}

export const renderSnippet = (nonce: string) =>
  renderSnippetGta(nonce, GA_TRACKING_ID)

const gtagIsNotAvailable = () => typeof window === 'undefined' || !window.gtag

export const pageView = () => {
  if (gtagIsNotAvailable()) return
  window.gtag('config', GA_TRACKING_ID)
}

const gtgEvent = (action: any, infoObject: any) => {
  if (gtagIsNotAvailable()) return
  window.gtag('event', action, infoObject)
}

export const impressions = (productList: any) => {
  if (!productList?.length) return

  let index = 0
  const gtmProductList = productList.reduce(
    (accumulated: any, product: any) => {
      return [
        ...accumulated,
        ...(product.skus?.map((productVariation: any) => {
          const gtgProduct = gtgProdutoFromLinx(product, {
            list_position: index,
          })

          ++index

          return {
            ...gtgProduct,
            id: removeSkuPrefix(productVariation?.sku),
            variant: productVariation.specs?.cor?.[0],
            price: productVariation.properties.price,
          }
        }) || []),
      ]
    },
    []
  )

  gtgEvent('view_item_list', {
    items: gtmProductList,
  })
}

export const productClick = (product: any) => {
  gtgEvent('select_content', {
    items: [gtgProdutoFromLinx(product)],
  })
}

export const productDetails = (conteudoProduto: any, variacaoAtiva: any) => {
  gtgEvent('view_item', {
    items: [gtgProduto(conteudoProduto, variacaoAtiva)],
  })
}

export const addToCart = (produto: any) => {
  gtgEvent('add_to_cart', {
    items: [produto],
  })
}

export const removeFromCart = (produto: any) => {
  gtgEvent('remove_from_cart', {
    items: [produto],
  })
}
